
import { Navigate, useLocation } from "react-router-dom";
import { getAllowedRoutes } from "./getAllowedRoutes";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const user = sessionStorage.getItem("user");
  const power = sessionStorage.getItem("power");

  //  allow identity page always
  if (currentPath.startsWith("/identity")) {
    return children;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (power === null) {
    return null;
  }

  //  allow contact demo
  if (currentPath.startsWith("/contact-demo")) {
    return children;
  }

  if (power !== "1") {
    if (!currentPath.startsWith("/profile/plans")) {
      return <Navigate to="/Profile/Plans" replace />;
    }
    return children;
  }

  const entitlement =
    JSON.parse(sessionStorage.getItem("entitlement")) || [];

  const allowedRoutes = getAllowedRoutes(entitlement);

  if (currentPath === "/dashboard") {
    return children;
  }

  if (!allowedRoutes.length) {
    return children;
  }

  const isAllowed = allowedRoutes.some((route) => {
    return currentPath === route || currentPath.startsWith(route + "/");
  });

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;


// import { Navigate, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const location = useLocation();
//   const currentPath = location.pathname.toLowerCase();

//   const user = sessionStorage.getItem("user");

//   // Allow identity page always
//   if (currentPath.startsWith("/identity")) {
//     return children;
//   }

//   // Allow contact demo
//   if (currentPath.startsWith("/contact-demo")) {
//     return children;
//   }

//   // Basic login check only
//   if (!user) {
//     return <Navigate to="/" replace />;
//   }

//   // TEMP BYPASS:
//   // For now allow all protected routes after login
//   return children;
// };

// export default ProtectedRoute;